export default __webpack_public_path__ + "static/media/urlshortening.75c424fc.jpg";